var map = {
	"./Black_01.png": 8793,
	"./Black_01_Scene.jpg": 2004,
	"./Black_02.png": 4258,
	"./Black_02_Scene.jpg": 5591,
	"./Black_03.png": 5803,
	"./Black_03_Scene.jpg": 830,
	"./Black_04.png": 996,
	"./Black_04_Scene.jpg": 97,
	"./Copper_01.png": 537,
	"./Copper_01_Scene.jpg": 836,
	"./Copper_02.png": 9826,
	"./Copper_02_Scene.jpg": 3223,
	"./Copper_03.png": 7691,
	"./Copper_03_Scene.jpg": 8062,
	"./Copper_04.png": 2388,
	"./Copper_04_Scene.jpg": 4401,
	"./White_01.png": 6747,
	"./White_01_Scene.jpg": 8126,
	"./White_02.png": 6576,
	"./White_02_Scene.jpg": 9893,
	"./White_03.png": 2825,
	"./White_03_Scene.jpg": 8548,
	"./White_04.png": 406,
	"./White_04_Scene.jpg": 4963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9430;